import React from "react";

import { Props } from "./types";

function AddIcon({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 21 22"
    >
      <circle
        id="Ellipse_684"
        data-name="Ellipse 684"
        cx="10.5"
        cy="10.5"
        r="10.5"
      />
      <text
        transform="translate(6 17)"
        fill="#fff"
        font-size="18"
        font-family="ProximaNova-Bold, Proxima Nova"
        font-weight="700"
      >
        <tspan x="0" y="0">
          +
        </tspan>
      </text>
    </svg>
  );
}

export { AddIcon };
